module.exports = __webpack_public_path__ + "img/ff9afd4.png";